<template>
  <div>
    <my-menu
      v-model="drawer"
    ></my-menu>
    <v-app-bar
      :color="color"
      dark
      app
    >
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          :to="{ name: 'ordenes-datatable' }"
          text
        >
          Ordenes
        </v-btn>
        <v-btn
          :to="{ name: 'clientes-datatable' }"
          text
        >
          Clientes
        </v-btn>
        <v-btn text @click.stop="drawer = !drawer">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
        <!-- <v-btn text>
          <v-icon>mdi-menu</v-icon>
        </v-btn> -->
        <!--  
        <my-sucursal-select
        ></my-sucursal-select>
        <v-btn text @click.stop="drawer = !drawer">
          <v-icon dark left>mdi-account</v-icon>
          {{ username }}
        </v-btn>
        <v-btn text @click.stop="drawer = !drawer">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
        -->
      </v-toolbar-items>
    </v-app-bar>

    <v-main>
      <alertas-view></alertas-view>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
      <v-container>
        <my-forbidden></my-forbidden>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import AlertasView from '@/components/AlertasView'
import PermisosRefresh from '@/components/PermisosRefresh'
import Forbidden from '@/components/Forbidden'
import SucursalSelect from '@/pages/sucursales/Select'
import Menu from '@/pages/layouts/Menu'
export default {
  components: {
    'alertas-view': AlertasView,
    'my-permiso-refresh': PermisosRefresh,
    'my-forbidden': Forbidden,
    'my-sucursal-select': SucursalSelect,
    'my-menu': Menu,
  },
  data () {
    return {
      drawer: false,
    }
  },
  created () {
    //
  },
  computed: {
    ...mapGetters({
      user_name: 'Auth/name',
      email: 'Auth/email',
    }),
    username () {
      return this.user_name ? this.user_name.split(' ')[0] : 'Ninguno'
    },
    title () {
      return this.$route.meta.title || 'Sin autorización'
    },
    color () {
      return this.$route.meta.color || 'toolbar'
    },
  },
  methods: {
    ...mapActions({
      onFetch: 'Ordenes/onFetch',
      onLogout: 'Auth/onLogout',
    }),
    ...mapMutations({
      setPage: 'Ordenes/setPage',
    }),
    onSubmitLogout () {
      this.onLogout()
        .then(
          this.$router.push({ name: 'login' })
        )
    },
  }
}
</script>